import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum GiftVoucherValueTextColorId {
  BLACK = 'black',
  WHITE = 'white',
}

export class GiftVoucherValueTextColor extends Codebook<GiftVoucherValueTextColorId> {
  static readonly BLACK = new GiftVoucherValueTextColor(GiftVoucherValueTextColorId.BLACK, () =>
    $t('Black'),
  )
  static readonly WHITE = new GiftVoucherValueTextColor(GiftVoucherValueTextColorId.WHITE, () =>
    $t('White'),
  )

  private constructor(
    public readonly value: GiftVoucherValueTextColorId,
    public readonly label: () => string,
  ) {
    super(value)
  }
}
